<p-dialog
  header="空飛箱數編輯"
  appendTo="body"
  (onHide)="hideModal($event)"
  [(visible)]="display"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '30%' }"
  [breakpoints]="{ '1024px': '60%', '800px': '75%', '550px': '90%' }"
>
  <ng-container>
    <div [formGroup]="form" class="p-fluid formgrid">
      <div class="field grid">
        <label class="col-4">交貨單號</label>
        <div class="col-8">
          {{dropDO?.doNo}}
        </div>
      </div>

      <div class="field grid">
        <label class="col-4">種類</label>
        <div class="col-8">
          <div class="formgroup-inline">
            <div class="field-radiobutton">
              <p-radioButton
                formControlName="dropType"
                name="dropType"
                value="I"
                label="廠內空飛"
                [(ngModel)]="model.dropType"
              ></p-radioButton>
            </div>
            <div class="field-radiobutton">
              <p-radioButton
                formControlName="dropType"
                name="dropType"
                value="O"
                label="廠外空飛"
                [(ngModel)]="model.dropType"
              ></p-radioButton>
            </div>
          </div>
          <div>
            <small
              *ngIf="
                form.controls.dropType.invalid &&
                (submitted || form.controls.dropType.touched) &&
                  form.controls.dropType.errors?.required
              "
              class="p-invalid"
              >{{ "Common.Button.Required" | translate }}</small
            >
          </div>
        </div>
      </div>

      <div class="field grid">
        <label class="col-4">業務</label>
        <div class="col-8">
          {{dropDO?.salesCode}}
        </div>
      </div>

      <div class="field grid">
        <label class="col-4">業助</label>
        <div class="col-8">
          {{dropDO?.csr}}
        </div>
      </div>

      <div class="field grid">
        <label class="col-4">總箱數</label>
        <div class="col-8">
          <p-inputNumber formControlName="cartonCntTmp" name="cartonCntTmp" [(ngModel)]="model.cartonCntTmp" [disabled]="model.cartonCnt != null && model.cartonCnt >= 1"></p-inputNumber>
          <small
            *ngIf="form.controls.cartonCntTmp.invalid && ((submitted || form.controls.cartonCntTmp.touched) && form.controls.cartonCntTmp.errors?.min)"
            class="p-invalid">必須大於0</small>
          <small
            *ngIf="form.controls.cartonCntTmp.invalid && ((submitted || form.controls.cartonCntTmp.touched) && form.controls.cartonCntTmp.errors?.required)"
            class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
        </div>
      </div>
      <div class="field grid">
        <label class="col-4 mt-2">總毛重</label>
        <div class="col-8">
          <p-inputNumber formControlName="totalGrossWeight" name="totalGrossWeight" [(ngModel)]="model.totalGrossWeight" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
          <small
            *ngIf="((submitted || form.controls.totalGrossWeight.touched) && form.controls.totalGrossWeight.errors?.min)"
            class="p-invalid">必須大於0</small>
            <small
            *ngIf="((submitted || form.controls.totalGrossWeight.touched) && form.controls.totalGrossWeight.errors?.required)"
            class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
        </div>
      </div>
      <div class="field grid">
        <label class="col-4 mt-2">總淨重</label>
        <div class="col-8">
          <p-inputNumber formControlName="totalNetWeight" name="totalNetWeight" [(ngModel)]="model.totalNetWeight" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
          <small
            *ngIf="((submitted || form.controls.totalNetWeight.touched) && form.controls.totalNetWeight.errors?.min)"
            class="p-invalid">必須大於0</small>
        </div>
      </div>
      <div class="field grid">
        <label class="col-4 mt-2">材積重</label>
        <div class="col-8">
          <p-inputNumber formControlName="volumeWeight" name="volumeWeight" [(ngModel)]="model.volumeWeight" [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
          <small
            *ngIf="((submitted || form.controls.volumeWeight.touched) && form.controls.volumeWeight.errors?.min)"
            class="p-invalid">必須大於0</small>
            <small
            *ngIf="((submitted || form.controls.volumeWeight.touched) && form.controls.volumeWeight.errors?.required)"
            class="p-invalid">{{ 'Common.Button.Required' | translate }}</small>
        </div>
      </div>
    </div>
    <div class="grid mt-2">
      <div class="col text-center">
        <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}"
          (click)="modalConfirmBtnClick($event)"></button>
        <button pRipple pButton label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2"
          (click)="modalCancelBtnClick($event)"></button>
      </div>
    </div>
  </ng-container>
</p-dialog>
